export default __webpack_public_path__ + "static/media/Sage's Helm of the Green Ones.aaac0d2d.jpg";